import { createStore, applyMiddleware, Store } from 'redux';
import thunk from 'redux-thunk';

import createReducer from './reducers';
import { AvailableLanguages } from './reducers/available-languages';
import { Config } from '../lib/config';

export type DynamicReducerStore = Store<{}> & { dynamicReducers: object };

/* eslint-disable no-console */
const logger = (store) => (next) => (action) => {
  console.group(action.type);
  console.info('dispatching', action);
  const result = next(action);
  console.log('next state', store.getState());
  console.groupEnd();
  return result;
};

export default function configureStore(initialState = {}) {
  const store = createStore(
    createReducer(),
    initialState,
    applyMiddleware(logger, thunk)
  ) as DynamicReducerStore;
  store.dynamicReducers = {};
  return store;
}

export type State = {
  availableLanguages: AvailableLanguages;
  config: Config;
};



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/store/index.ts